import React from "react"
import "./styles.css"
import LanguageSelector from "../../container/language-selector/LanguageSelector";
import {DropdownInput, Text} from "atmosfair-ui"
import {useNavigate} from "react-router-dom";
import {PATH_STRINGS} from "../../routes/route-props";
import {convertLufToDropdownFormat} from "../../utils/converter/dropdown";
import {COOKIE_NAME, Luf} from "../../constants/default-values";
import {useTranslation} from "react-i18next";
import {capitalizeFirstLetter} from "../../utils/string/common";
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import ToastWithTextOnly from "../toasts/toast-with-text-only/ToastWithTextOnly";

const Footer = () => {
    const navigate = useNavigate()
    const {i18n} = useTranslation()

    const downloadLuf = async (payload: string) => {
        const isProduction = process.env.REACT_APP_INSTANCE === "prod"
        const urlForDownload = isProduction
            ? 'https://api.klimalink.org/api/v1/downloadLookupFile'
            : 'https://api.dev.klimalink.org/api/v1/downloadLookupFile'
        try {
            const response = await fetch(
                `${urlForDownload}${payload}`,
                {
                    headers: {
                        Authorization: `Bearer ${Cookies.get(COOKIE_NAME)}`,
                    },
                }
            )
            if (response.status !== 200) {
                if (response.status === 401) {
                    toast(<ToastWithTextOnly
                            message={"TOASTS.ERROR.LUF_NO_ACCESS_RIGHTS"}/>,
                        {progress: undefined, type: "error"}
                    );
                } else {
                    toast(<ToastWithTextOnly
                            message={"TOASTS.ERROR.GENERAL"}/>,
                        {progress: undefined, type: "error"}
                    );
                }
                return
            } else {
                const blob = await response.blob()
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `Lookup-File-${payload}-${!isProduction ? capitalizeFirstLetter("test") : capitalizeFirstLetter("production")}.csv`
                document.body.appendChild(a)
                a.click()
                a.remove()
                window.URL.revokeObjectURL(url)
            }
        } catch (e) {
            toast(<ToastWithTextOnly
                    message={"TOASTS.ERROR.GENERAL"}/>,
                {progress: undefined, type: "error"}
            );
            console.warn(e)
        }
    };


    return <footer className={"footer-container"}>
        <div className={"footer-help-text-wrapper"}>
            <DropdownInput
                iconOnlyListBoxWidth={100}
                useSelection={false}
                label={"GENERAL.LUF"}
                listBoxPosition={"top"}
                iconOnlyColor={"white"}
                iconOnlyIcon={"cloudArrowDown"}
                iconOnlySize={"small"}
                iconOnly={true}
                options={convertLufToDropdownFormat(Luf, i18n)}
                setSelection={selection => selection && downloadLuf(capitalizeFirstLetter(selection[0].raw.name))}/>
            <Text
                classes={'footer-text-link'}
                onClick={() => navigate(PATH_STRINGS.help)}
                color={"white"}
                variant={"subtitleLarge"}>
                GENERAL.HELP
            </Text>
            <Text
                classes={'footer-text-link'}
                onClick={() => navigate(PATH_STRINGS.termsAndConditionsAdmin, {state: {showAcceptButton: false}})}
                color={"white"}
                variant={"subtitleLarge"}>
                GENERAL.TERMS
            </Text>
            <Text
                onClick={() => window.open('https://klimalink.org/emissionen-berechnen/#berechnungsstandards', '_blank')?.focus()}
                classes={"footer-text-link"}
                color={"white"}
                variant={"subtitleLarge"}>
                GENERAL.CALCULATION
            </Text>
        </div>
        <LanguageSelector/>
    </footer>
}

export default Footer